import { render, staticRenderFns } from "./addProviderMarkupModal.vue?vue&type=template&id=0454bc3d&scoped=true&"
import script from "./addProviderMarkupModal.vue?vue&type=script&lang=ts&"
export * from "./addProviderMarkupModal.vue?vue&type=script&lang=ts&"
import style0 from "./addProviderMarkupModal.vue?vue&type=style&index=0&id=0454bc3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0454bc3d",
  null
  
)

export default component.exports